import moment from 'moment';

export const getCurrentDateTime = () => new Date();

export const getFormattedDate = () => moment(Date.now()).format('L');

export const convertDateToEpoch = date => moment(date).valueOf();
